<div class="container-fluid">
  <page-header-search
    [isSearchInput]="false"
    [pageTitleValue]="pageTitle"
  ></page-header-search>

  <div *ngIf="filteredDoctorsArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Featured Doctors</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredDoctorsArray">
              <td>
                <span>{{ item.fullName }}</span>
              </td>
              <td>
                <span>{{ item.arFullName }}</span>
              </td>
              <td>
                <span>{{ item.title }}</span>
              </td>
              <td>
                <span>{{ item.arTitle }}</span>
              </td>
              <td>
                <span>{{ item.topDoctorRank }}</span>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteDoctor($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
